module.exports = __webpack_public_path__ + "static/orange-fe6fe8a662741cbe8a1bf323dafbd2b9.svg";